import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

import Config from "legacy/config";

export const TerminalGroups = {
  callDetails: {
    displayName: "Call Details"
  },
  demographics: {
    displayName: "Caller Profile"
  },
  reportedData: {
    displayName: "Reported Data"
  },
  invocaObjects: {
    displayName: "Invoca Platform Details"
  }
};

export const staticTerminals = {
  "&&": { type: "conjunction" },
  "and": { type: "conjunction" },
  "||": { type: "conjunction" },
  "or": { type: "conjunction" },
  "(": { type: "paren" },
  ")": { type: "paren" },
  "not": { type: "not" },
  "!": { type: "not" }
};

const onVoiceInsert = function(nodeAttrs, onSuccess) {
  // need to grab reference to the backdraft app - and the code actually uses the `app` reference internally (!)
  var app = Backdraft.app("Shared/ExpressionBuilder");
  var voiceModel = new app.Models.VoiceKeyword();
  voiceModel.setDefaultState();

  var modal = new app.Views.VoiceFormModal({
    model: voiceModel
  });

  modal.on('save', function() {
    var node = _.extend({}, nodeAttrs, voiceModel.toJSON());
    onSuccess(node);
  });

  modal.render();
};

export const beforeInsertTerminalMapping = {
  voice_signal: onVoiceInsert
};

const TerminalMetaData = function() {
  return {
    // Terminals listed in order they will appear in the Expression Builder UI

    // Call Details group
    duration: {
      displayName: "Duration",
      groupName: TerminalGroups.callDetails.displayName,
      type: "duration"
    },
    connect_duration: {
      displayName: "Connect Duration",
      groupName: TerminalGroups.callDetails.displayName,
      type: "duration"
    },
    landline: {
      displayName: "Phone Type",
      groupName: TerminalGroups.callDetails.displayName,
      type: "phone_type"
    },
    mobile: {
      displayName: "Phone Type",
      groupName: TerminalGroups.callDetails.displayName,
      access: { sharedTerminal: "landline" },
      type: "phone_type"
    },
    sms_sent: {
      displayName: "SMS Sent",
      groupName: TerminalGroups.callDetails.displayName,
      type: 'boolean'
    },
    during_hours: {
      displayName: "During Hours",
      groupName: TerminalGroups.callDetails.displayName,
      type: 'boolean'
    },
    repeat: {
      displayName: "Repeat Caller",
      groupName: TerminalGroups.callDetails.displayName,
      type: 'boolean'
    },
    voice_signal: {
      displayName: "Spoken Phrases",
      groupName: TerminalGroups.callDetails.displayName,
      beforeInsert: onVoiceInsert,
      access: { feature: "voice" },
      type: "voice"
    },
    end_of_call_reason: {
      displayName: "End of Call Reason",
      groupName: TerminalGroups.callDetails.displayName,
      type: "string_compare"
    },

    // Caller Profile group
    age: {
      displayName: "Age",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["WhitePages", "Infutor"] },
      type: "age"
    },
    gender: {
      displayName: "Gender",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["WhitePages", "Infutor"] },
      type: "string_list"
    },
    address_type: {
      displayName: "Address Type",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["WhitePages", "Infutor"] },
      type: "string_list"
    },
    household_income: {
      displayName: "Household Income",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: "money_compare"
    },
    marital_status: {
      displayName: "Marital Status",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: "string_list"
    },
    has_children: {
      displayName: "Has Children",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: 'boolean'
    },
    home_owner_status: {
      displayName: "Home Owner Status",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: "string_list"
    },
    home_market_value: {
      displayName: "Home Market Value",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: "money_compare"
    },
    length_of_residence: {
      displayName: "Length of Residence",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: "number_compare"
    },
    education: {
      displayName: "Education",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: "string_list"
    },
    occupation: {
      displayName: "Occupation",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: "string_list"
    },
    high_net_worth: {
      displayName: "High Net Worth",
      groupName: TerminalGroups.demographics.displayName,
      access: { feature: "enhancedCallerProfiles", values: ["Infutor"] },
      type: 'boolean'
    },

    // Reported Data group
    signal: {
      displayName: "Signal",
      relOpConfig: { hideContains: true, hidePresent: true },
      groupName: TerminalGroups.reportedData.displayName,
      type: "string_compare"
    },
    previous_signal: {
      displayName: "Previous Signal",
      relOpConfig: { hideContains: true, hidePresent: true },
      groupName: TerminalGroups.reportedData.displayName,
      type: "string_compare"
    },
    pool_param: {
      displayName: "RingPool Parameter",
      groupName: TerminalGroups.reportedData.displayName,
      type: "pool_param"
    },
    custom_data: {
      displayName: "Marketing Data",
      groupName: TerminalGroups.reportedData.displayName,
      access: { feature: "customerDictionary" },
      type: "custom_data"
    },
    adwords_data: {
      displayName: "Adwords Data",
      groupName: TerminalGroups.reportedData.displayName,
      access: { feature: "adwordsDataEnabled" },
      type: "adwords_data"
    },

    // Invoca Platform Details group
    advertiser_name: {
      displayName: Config.localization.advertiserNameFromNetwork.toString(false, false, false, true) + " Name",
      groupName: TerminalGroups.invocaObjects.displayName,
      access: { feature: "customDataAccessLevel", values: ["Brand"] },
      type: "string_compare"
    },
    affiliate_name: {
      displayName: Config.localization.affiliateNameFromNetwork.toString(false, false, false, true) + " Name",
      groupName: TerminalGroups.invocaObjects.displayName,
      access: { feature: "showAffiliates", values: [true] },
      type: "string_compare"
    },
    advertiser_campaign_name: {
      displayName: "Campaign Name",
      groupName: TerminalGroups.invocaObjects.displayName,
      type: "string_compare"
    },
    media_type: {
      displayName: "Promo Number Media Type",
      groupName: TerminalGroups.invocaObjects.displayName,
      type: "string_compare"
    },
    promo_number_description: {
      displayName: "Promo Number Description",
      groupName: TerminalGroups.invocaObjects.displayName,
      type: "string_compare"
    }
  };
};

export default TerminalMetaData;
